import { render, staticRenderFns } from "./QuarterlySlideFactory.vue?vue&type=template&id=852e285c&scoped=true&"
import script from "./QuarterlySlideFactory.vue?vue&type=script&lang=js&"
export * from "./QuarterlySlideFactory.vue?vue&type=script&lang=js&"
import style0 from "./QuarterlySlideFactory.vue?vue&type=style&index=0&id=852e285c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852e285c",
  null
  
)

export default component.exports